import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable, defer } from 'rxjs';
import { Device } from '@capacitor/device';
import CryptoES from 'crypto-es';

@Injectable({ providedIn: 'root' })
export class AuthHeaderService {
  /**
   * Builds device‑attestation headers:
   *   X-Device-Id          → Capacitor Device ID
   *   X-Device-Timestamp   → ISO‑8601 string (UTC)
   *   X-Device-Signature   → SHA‑256(deviceId:unixMillis) – *hex*
   *
   * Note the **hash uses unix epoch milliseconds**, *not* the ISO string.
   */
  build(): Observable<HttpHeaders> {
    return defer(async () => {
      const { identifier: deviceId } = await Device.getId();

      const now = new Date();
      const unixMillis = now.getTime(); // ms since 1970‑01‑01 UTC
      const isoString = now.toISOString(); // header value

      const digest = CryptoES.SHA256(`${deviceId}:${unixMillis}`).toString(CryptoES.enc.Hex);

      return new HttpHeaders({
        'X-Device-Id': deviceId,
        'X-Device-Timestamp': isoString,
        'X-Device-Signature': digest,
      });
    });
  }
}
